var React = require('react');

function ArrowDownBlack (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#2c2c3d","fillRule":"nonzero","stroke":"#2c2c3d","d":"M15.782 1.203a.53.53 0 0 0-.744 0L8.5 7.693l-6.551-6.49a.53.53 0 0 0-.744 0 .518.518 0 0 0 0 .737l6.91 6.844c.103.102.231.153.372.153.128 0 .27-.051.372-.153l6.91-6.844a.507.507 0 0 0 .013-.737z"}));
}

ArrowDownBlack.defaultProps = {"width":"17","height":"10","viewBox":"0 0 17 10"};

module.exports = ArrowDownBlack;

ArrowDownBlack.default = ArrowDownBlack;
